import 'normalize.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Icon from '@/components/common/Icon.vue'
import Spacer from '@/components/common/Spacer.vue'
import Divider from '@/components/common/Divider.vue'
import Collapse from '@/components/common/Collapse.vue'
import TransitionPlusButton from '@/components/common/TransitionPlusButton.vue'
import 'vue-datepicker-next/locale/zh-tw'

import VueLazyload from 'vue-lazyload'

import '@/assets/scss/datepicker.scss'
import 'vue-slider-component/theme/default.css'
import '@/assets/scss/Global.scss'
import '@/assets/main.css'
import Toast, { POSITION, PluginOptions } from 'vue-toastification'
import '@/assets/scss/toast.scss'
// import 'vue-toastification/dist/index.css'
import Directives from '@/utils/directives'
import VueGtag from 'vue-gtag'
import { createGtm } from '@gtm-support/vue-gtm'

const options: PluginOptions = {
  transition: {
    enter: 'fade-enter-active',
    leave: 'fade-leave-active',
    move: 'fade-move'
  },
  position: POSITION.BOTTOM_RIGHT,
  timeout: 1000,
  maxToasts: 1
  // You can set your default options here
}

createApp(App)
  .component('Icon', Icon)
  .component('Spacer', Spacer)
  .component('Divider', Divider)
  .component('Collapse', Collapse)
  .component('TransitionPlusButton', TransitionPlusButton)
  .use(store)
  .use(router)
  .use(Toast, options)
  .use(Directives)
  .use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
  })
  // .use(VueGtag, {
  //   config: {
  //     id: 'G-BP7911WQSQ'
  //   }
  // }, router)
  .use(
    createGtm({
      // id: 'GTM-K7JLV9P', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      id: window._env_.GTM_ID,
      // queryParams: {
      //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
      //   gtm_preview: 'env-4',
      //   gtm_cookies_win: 'x',
      // },
      // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      // nonce: '2726c7f26c', // Will add `nonce` to the script tag
      // enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: true, // Whether or not display console logs debugs (optional)
      // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router // Pass the router instance to automatically sync with router (optional)
      // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
      // trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
    })
  )
  .mount('#app')
